import React, { useState, useEffect } from "react";
import "../Css/Navbar.css";
import { useNavigate, useLocation } from "react-router-dom";
import SvgIcons from "../Icons/SvgIcons.jsx";
import AddDeviceDialog from "./modals/AddDevice/AddDevice.jsx"; // Importuj komponent AddDeviceDialog
import Content from "../utils/content.json"; // Importuj komponent Content

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation(); // Hook to get the current route
  const [isAddDeviceModalOpen, setIsAddDeviceModalOpen] = useState(false);
  const [username, setUsername] = useState(""); // Stan dla nazwy użytkownika

  // Pobierz username z initial_data przy montowaniu komponentu
  useEffect(() => {
    const storedData = localStorage.getItem('initial_data');
    if (storedData) {
      try {
        const initialData = JSON.parse(storedData);
        if (initialData && initialData.user && initialData.user.username) {
          setUsername(initialData.user.username);
        }
      } catch (error) {
        console.error("Error parsing initial data:", error);
      }
    }
  }, []);

  const getNavbarContent = () => {
    for (const path in Content) {
      if (location.pathname.startsWith(path)) {
        return Content[path];
      }
    }
    return [];
  };

  const headerLeft = getNavbarContent();

  return (
    <div>
        <div className="container header flex">
          <div className="header-left flex">
            {headerLeft.map(({ name, screen, navigateTo }) => (
              <button
                key={name}
                className={` ${
                  location.pathname === navigateTo ? "active" : ""
                }`}
                onClick={() =>
                  navigateTo ? navigate(navigateTo) : console.log("No route")
                }
              >
                {name === "Devices" ? <SvgIcons.Devices /> : name}
              </button>
            ))}
          </div>

          <div className="header-right flex">
            <button className="btn-mode"><SvgIcons.WhiteMode /></button>
            <button className="btn-settings"><SvgIcons.Gear /></button>
            <button className="btn-profile flex">
              <SvgIcons.Account />
              <div className="profile-name">{username || "User"}</div>
            </button>
          </div>
        </div>
     

      <AddDeviceDialog
        isOpen={isAddDeviceModalOpen}
        onClose={() => setIsAddDeviceModalOpen(false)}
      />
    </div>
  );
}

export default Navbar;
